import React from 'react';
import { ChildProfilePageStep, CommonPageStep } from '..';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AvatarSelect } from './avatarSelect';
import styles from './childProfile.module.css';
import { CreateChildProfile } from './createChildProfile';
import { Created } from './created';
import { logoutBbl } from '../../common/CommonTools';
import BblButton from '../../component/buttons/bblButton';
import { useAppSelector } from '../../store/hooks';
import {
  selectAppAuthentication,
  selectAppPageStep,
  setAppPageStep,
} from '../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../store/store';

export const ChildProfile = (): JSX.Element => {
  // Redux
  const pageStep = useAppSelector(selectAppPageStep);
  const authenticationData = useAppSelector(selectAppAuthentication);

  // Page functions
  const storeUserSessionInfo = (): void => {
    const sessionInfoString = JSON.stringify({ ...authenticationData });
    window.localStorage.setItem('bigbang_session_info', sessionInfoString);
  };

  React.useEffect(() => {
    outsideComponentDispatch(setAppPageStep(CommonPageStep.CHILD_PROFILE));
    outsideComponentDispatch(setAppPageStep(ChildProfilePageStep.CREATE));
  }, []);

  React.useEffect(() => {
    if (authenticationData) {
      storeUserSessionInfo();
    }
  }, [authenticationData]);

  return (
    <React.Fragment>
      <div className={styles.createChildProfile}>
        <header className={styles.header} id="bbl-header">
          <img
            className={styles.bBALogo2}
            id="bba-logo"
            alt=""
            src="assets/common/bba-logo.svg"
          />
          <BblButton color="primary" size="small" onClick={logoutBbl} mute>
            Log Out
          </BblButton>
        </header>
        <div
          className={styles.createChildProfileCardDiv}
          id="create-child-profile-card"
        >
          {pageStep === CommonPageStep.CHILD_PROFILE ? <Created /> : null}
          {pageStep === ChildProfilePageStep.CREATE ? (
            <CreateChildProfile />
          ) : null}
          {pageStep === ChildProfilePageStep.CREATED ? <Created /> : null}
          {pageStep === ChildProfilePageStep.AVATAR ? <AvatarSelect /> : null}
        </div>
        <img
          className={styles.backgroundIcon}
          alt=""
          src="assets/childProfile/background@3x.png"
        />
      </div>

      {pageStep === CommonPageStep.BIGBANGLAB ? (
        <Navigate to={`/BigBangLab`} />
      ) : null}
    </React.Fragment>
  );
};
